export const SEND_PAGE_ANALYTICS = 'SEND_PAGE_ANALYTICS';
export const TRACK_EVENT = 'TRACK_EVENT';
export const TRACK_EVENT_FORM_SUBMISSION = 'TRACK_EVENT_FORM_SUBMISSION';
